import React, { useEffect, useContext }	from "react";
import { Button }						from "react-bootstrap";
import {
	CloudSlash,
	CloudCheck,
	CircleNotch
}										from "@phosphor-icons/react";
import globalContext					from "../utils/globalContext";

const states = {
	saving: {
		icon: <CircleNotch size={16} className="spin" weight="bold" />,
		text: "Saving...",
		css: "feedback-saving"
	},
	finished: {
		icon: <CloudCheck size={16} weight="bold" />,
		text: "Saved",
		css: "feedback-finished"
	},
	saved: {
		icon: <CloudCheck size={16} weight="bold" />,
		text: "",
		css: ""
	},
	error: {
		icon: <CloudSlash size={16} weight="bold" />,
		text: "Failed",
		css: "feedback-failed"
	},
};

export default function SaveFeedback() {

	const context	= useContext(globalContext);
	const saveState	= context.getters?.saveState ?? 'saved';

	useEffect(() => {
		if (saveState !== 'finished') return;
		const t = setTimeout(() => context.setters.setSaveState('saved'), 1500);
		return () => clearTimeout(t);
	}, [saveState]);

	const state = states[saveState] ?? states.saved;

	return <Button className={"savefeedback " + state.css}>{state.icon} {state.text}</Button>;
}